import { AppForm, AppFormItem, formRules } from 'shared/UI/UIKit/Form';
import { AppInput } from 'shared/UI/UIKit/Input';
import { AppSelect } from 'shared/UI/UIKit/Select';
import type { MunicipalityFormProps } from './types';

export const MunicipalityForm = (props: MunicipalityFormProps) => {
  return (
    <AppForm form={props.form}>
      <AppFormItem
        label="Название муниципалитета"
        labelColor="gray"
        size="max"
        name="name"
        rules={formRules.required}
      >
        <AppInput placeholder="Название муниципалитета" />
      </AppFormItem>
      <AppFormItem
        label="Регион"
        labelColor="gray"
        size="max"
        name="regionId"
        rules={formRules.requiredNumber}
      >
        <AppSelect
          options={props.regionOptions}
          placeholder="Выберите регион"
          loading={props.regionsLoading}
          allowClear
        />
      </AppFormItem>
    </AppForm>
  );
};
